import React from 'react';
import logo from '../../StaticContent/Multilayer-aht-logo.png';

import { Typography, Card } from '@mui/material';

import './multiClick.css';

const MultiClick = () => {
  return (
    <Card
      className='multiClickDiv'
      sx={{
        maxWidth: 345,
        border: 'none',
        boxShadow: 'none',
        margin: ' 0 auto',
        padding: '1px',
      }}
    >
      <img
        className='multiPic'
        style={{ maxWidth: '80px', maxHeight: '100%', padding: '2px' }}
        src={logo}
        alt='logo'
      />
      <Typography className='multiClick'>MultiClick</Typography>
    </Card>
  );
};

export default MultiClick;
